import { CssBaseline, ThemeProvider } from "@mui/material";
import { isEmpty, reverse } from "lodash";
import { FC, ReactElement } from "react";
import theme from "theme";
import { LanguageProvider } from "./LanguageProvider";
import { ReviewProvider } from "./ReviewProvider";
import { QueryClientProvider } from "./QueryClientProvider";

declare module "@mui/material/styles/createPalette" {
	interface Palette {
		violet: Palette["primary"];
	}
	interface PaletteOptions {
		violet: PaletteOptions["primary"];
	}
}

export interface IProvider {
	children: ReactElement<any, any> | null;
}

const providers = [
	({ children }: IProvider) => <ThemeProvider theme={theme}>{children}</ThemeProvider>,
	CssBaseline,
	QueryClientProvider,
	LanguageProvider,
	ReviewProvider,
];

export const Providers: FC<IProvider> = ({ children }) => {
	if (isEmpty(providers)) return children;
	return reverse(providers).reduce((sum, Provider) => <Provider>{sum}</Provider>, children);
};
